<div class="flex flex-col justify-between h-full">
  <!-- Form Content -->
  <div class="p-6" [formGroup]="form">
    <div class="flex flex-col gap-4">
      <div class="flex flex-col gap-6">
        <app-form-card title="Who is driving?" icon="Users">
          <div class="pb-1">
            <app-checkbox
              label="Team Load (2 Co-Drivers)"
              [ngModel]="isTeamLoad()"
              (ngModelChange)="toggleTeamLoad($event)"
              [ngModelOptions]="{ standalone: true }"
            ></app-checkbox>
          </div>
          <app-form-field label="Driver 1">
            <app-select
              formControlName="driver1"
              [options]="driverOptions()"
              placeholder="Select driver"
            ></app-select>
          </app-form-field>
          <app-driver-credential-warning [driver]="selectedDriver1()" [loadDate]="loadEndDate" />
          @if (isTeamLoad()) {
            <app-form-field label="Driver 2 (Co-Driver)">
              <app-select
                formControlName="driver2"
                [options]="driverOptions()"
                placeholder="Select co-driver"
              ></app-select>
            </app-form-field>
            <app-driver-credential-warning [driver]="selectedDriver2()" [loadDate]="loadEndDate" />
          }
        </app-form-card>
        <app-form-card title="Truck Details" icon="Truck">
          <app-form-field label="Truck">
            <app-select
              formControlName="truck"
              [options]="truckOptions()"
              placeholder="Select truck"
            ></app-select>
          </app-form-field>
          <app-form-field label="Trailer">
            <app-select
              formControlName="trailer"
              [options]="trailerOptions()"
              placeholder="Select trailer"
            ></app-select>
          </app-form-field>
        </app-form-card>
      </div>
    </div>
  </div>
  <!-- Modal Actions -->
  <div
    class="flex flex-col-reverse lg:flex-row justify-end gap-3 p-2 md:p-4 border-t border-border"
  >
    <app-button variant="secondary" (click)="cancel()" [disabled]="isSaving()">
      Cancel
    </app-button>
    <app-button
      (click)="save()"
      [disabled]="form.invalid || isSaving()"
      [loading]="isSaving()"
    >
      {{ isSaving() ? "Saving..." : "Save Changes" }}
    </app-button>
  </div>
</div>
